import { Provider } from '@angular/core';
import { ZOOM_CLIENT_ID } from '@services';

export function provideZoomClientId(apiKey: string): Provider[] {
  return [{ provide: ZOOM_CLIENT_ID, useValue: apiKey }];
}
